export default {
    language: "Deutsch",
    StripeSuccess: {
        loading: "Ihre Zahlung wird verarbeitet...",
        successMessage: "Ihr Abonnement wurde erfolgreich aktiviert!",
        processingError: "Zahlungsverarbeitung fehlgeschlagen, bitte kontaktieren Sie uns",
    },
    UserDetail: {
        userInfo: {
            emailLabel: "E-Mail",
            createdAt: "Erstellt am",
            noRecord: "Keine Aufzeichnung",
            loginTime: "Anmeldezeit",
        },
        orders: {
            title: "Bestellverlauf",
            loading: "Wird geladen...",
            refresh: "Aktualisieren",
            orderAmount: "Betrag",
            points: "Punkte",
            createdAt: "Erstellt am",
            orderType: "Typ",
            status: "Status",
            noOrders: "Keine Bestellungen",
            goToSubscription: "Punkte kaufen",
            freeCredit: "Kostenlose Punkte",
            paidCredit: "Bezahlte Punkte",
            queryOrderFailed: "Abfrage der Bestellung fehlgeschlagen",
            statusPaid: "Bezahlt",
            statusPending: "Ausstehend",
            statusCancelled: "Storniert",
            statusDeactivated: "Deaktiviert",
            checkoutUrlNotAvailable: "Checkout-URL konnte nicht abgerufen werden",
            verifyingPayment: "Zahlungsstatus wird überprüft...",
            paymentSuccess: "Zahlung erfolgreich",
            paymentPending: "Bestellung wartet auf Zahlung, bitte schließen Sie die Zahlung ab",
            paymentFailed: "Zahlung fehlgeschlagen oder storniert",
            paymentStatus: "Zahlungsstatus",
            paymentStatusDescription: "Haben Sie die Zahlung abgeschlossen?",
            cancelPayment: "Zahlung abbrechen",
            completedPayment: "Zahlung abgeschlossen",
            warning: "Warnung",
            confirmCancelOrder: "Sind Sie sicher, dass Sie diese Bestellung stornieren möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
            cancel: "Abbrechen",
            confirm: "Bestätigen",
            cancellingOrder: "Bestellung wird storniert...",
            orderCancelledSuccess: "Bestellung storniert",
            cancelOrderFailed: "Stornierung der Bestellung fehlgeschlagen",
            checkOrderStatusFailed: "Überprüfung des Bestellstatus fehlgeschlagen",
            promptClick: "Klicken Sie auf den Status \"Ausstehend\", um mit der Zahlung fortzufahren",
        }
    },
    Order: {
        purchasePoints: "Punkte kaufen",
        subtitle: "Wählen Sie ein geeignetes Punktepaket, um den hochwertigen Wasserzeichenentfernungsdienst zu nutzen",
        loginReminderDesc: "Melden Sie sich an, um Punkte auszuwählen und zu kaufen",
        freeTag: "Kostenlos",
        freePlan: "Kostenloser Plan",
        autoActivated: "Automatisch aktiviert nach Login",
        points: "Punkte",
        autoIncluded: "Kostenlose Zugabe",
        discount: "Rabatt",
        purchase: "Jetzt kaufen",
        paymentStatusDescription: "Haben Sie die Zahlung abgeschlossen?",
        paymentNotCompleted: "Zahlung unvollständig",
        queryOrderFailed: "Abfrage des Bestellstatus fehlgeschlagen",
        cancelPayment: "Zahlung abbrechen",
        completedPayment: "Zahlung abgeschlossen",
        warning: "Warnung",
        confirmCancelOrder: "Sind Sie sicher, dass Sie diese Bestellung stornieren möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
        cancel: "Abbrechen",
        confirm: "Bestätigen",
        selectProductFirst: "Bitte wählen Sie zuerst ein Paket",
        creatingOrder: "Bestellung wird erstellt...",
        orderCreated: "Bestellung erfolgreich erstellt",
        createOrderFailed: "Erstellen der Bestellung fehlgeschlagen",
        checkoutUrlNotAvailable: "Zahlungslink konnte nicht abgerufen werden",
        cancellingOrder: "Bestellung wird storniert...",
        orderCancelledSuccess: "Bestellung storniert",
        cancelOrderFailed: "Stornierung der Bestellung fehlgeschlagen",
        verifyingPayment: "Zahlungsstatus wird überprüft...",
        paymentSuccess: "Zahlung erfolgreich",
        paymentPending: "Bestellung wartet auf Zahlung, bitte schließen Sie die Zahlung ab",
        paymentFailed: "Zahlung fehlgeschlagen oder storniert",
        checkOrderStatusFailed: "Überprüfung des Bestellstatus fehlgeschlagen",
        quickStart: "Schnellstart",
        shortTerm: "Kurzzeitige Nutzung",
        recommended: "Empfohlen",
        bestValue: "Bestes Preis-Leistungs-Verhältnis",
    },
    Login: {
        title: "Login",
        subtitle: "Schneller Login mit sozialen Konten",
        memberTip: "Melden Sie sich an, um auf weitere Funktionen zuzugreifen",
        types: [
            {
                id: 1,
                provider: "github",
                icon: "fab fa-github",
                desc: "Mit GitHub-Konto anmelden"
            },
            {
                id: 2,
                provider: "google",
                icon: "fab fa-google",
                desc: "Mit Google-Konto anmelden"
            }
        ],
        error: {
            serverError: "Serverfehler, bitte versuchen Sie es später erneut",
            networkError: "Netzwerkfehler, bitte überprüfen Sie Ihre Verbindung"
        }
    },
    OAuthCallback: {
        loading: "Login-Anfrage wird verarbeitet",
        pleaseWait: "Bitte warten, Login-Informationen werden überprüft...",
        error: "Login fehlgeschlagen",
        backToHome: "Zurück zur Startseite",
        success: "Login erfolgreich",
        redirecting: "Weiterleitung zur Startseite..."
    },
    Nav:{
        title: "ClixMagicAI",
        logo: "logo.png",
        menu: {
            pricing: "Preise",
            faq: "FAQ",
        },
        login: "Login",
        userMenu: {
            account: "Konto",
            logout: "Abmelden",
            credit: "Guthaben",
            freeCredit: "Kostenlos",
            paidCredit: "Gekauft",
            nextUpdate: "Nächstes Guthaben-Update",
            language: "Sprache",
            theme: "Design",
        },
        userMenuIcons: {
            account: "fas fa-user-circle",
            logout: "fas fa-sign-out-alt",
            credit: "fas fa-credit-card",
            language: "fas fa-globe",
            theme: "fas fa-moon",
        },
    },
    ProductAdv: {
        title: "ClixMagicAI Funktionen",
        advs: [
            {
                title: "KI-Erkennungsmotor: Automatische Identifizierung störender Elemente",
                desc: "Basierend auf Deep-Learning-Algorithmen erkennt es automatisch Wasserzeichen, Text, Gesichter und komplexe Hintergrundelemente in Bildern/Videos, ohne manuelle Markierung. Unterstützt Formate von Instagram, TikTok und anderen Plattformen, mit striktem Datenschutz.",
                beforeImage: "adv-before-1.jpg",
                afterImage: "adv-after-1.jpg",
                click: "Wasserzeichen entfernen"
            },
            {
                title: "Bildbereinigungsmeister: Logos/Datumsstempel schnell entfernen, Bildqualität erhalten",
                desc: "Präzises Entfernen von Marken-Wasserzeichen, Aufnahmedatum, Stickern und anderen störenden Elementen. Die KI repariert automatisch die Hintergrundtextur, sodass die Bilder nach der Bearbeitung natürlich wie das Original aussehen, perfekt für Social-Media-Posts.",
                beforeImage: "adv-before-2.jpg",
                afterImage: "adv-after-2.jpg",
                click: "Wasserzeichen entfernen"
            },
            {
                title: "Dynamische Wasserzeichen-Beseitigung: Laufende Untertitel/Plattform-Logos entfernen",
                desc: "Mit einem Klick YouTube-Endkarten, TikTok-Wasserzeichen und Lauftext entfernen. KI-Tracking verarbeitet jedes Frame, liefert flüssige 4K-Hochqualitätsvideos, unterstützt MP4/MOV und andere gängige Formate.",
                beforeImage: "adv-before-3.jpg",
                afterImage: "adv-after-3.jpg",
                click: "Wasserzeichen entfernen"
            }
        ]
    },
    Description:{
        title: "ClixMagicAI",
        desc: "Ein professionelles KI-gesteuertes Wasserzeichenentfernungstool, das Wasserzeichen in Bildern und Videos schnell und einfach mit natürlichen Ergebnissen bearbeitet.",
        fileTypes: {
            image: 'Bild-Wasserzeichenentfernung',
            pdf: 'PDF-Wasserzeichenentfernung',
            video: 'Video-Wasserzeichenentfernung'
        },
        marketingTags: [
            { id: "freeTrialTag", text: "Tägliche kostenlose Testversion", icon: "fa-gift" },
            { id: "imageTag", text: "Bild-Wasserzeichenentfernung", icon: "fa-image" },
            { id: "videoTag", text: "Video-Wasserzeichenentfernung", icon: "fa-video" },
            { id: "aiPoweredTag", text: "KI-gesteuert", icon: "fa-robot" },
            { id: "noRegTag", text: "Anmelden & Nutzen", icon: "fa-user-check" },
        ],
        videoPromt: "Demnächst verfügbar!",
        videoDesc: "Wir entwickeln die Video-Wasserzeichenentfernung, um Ihnen ein noch leistungsfähigeres Erlebnis zu bieten."
    },
    Footer: {
        social: {
            title: "Kontaktieren Sie uns",
            logo: "logo.png",
            methods:[
                {
                    icon: "x-platform-icon",
                    link: "https://x.com/ClixMagicAI"
                },
                {
                    icon: "far fa-envelope",
                    link: "mailto:clixmagicai@gmail.com",
                    text: "clixmagicai@gmail.com"
                },
            ]
        },
        termsTitle: "Rechtliche Bedingungen",
        terms: [
            {
                id: 1,
                title: "Datenschutzrichtlinie",
                link: "/privacy"
            },
            {
                id: 2,
                title: "Nutzungsbedingungen",
                link: "/terms"
            },
            {
                id: 3,
                title: "Cookie-Richtlinie",
                link: "/cookie"
            }
        ],
        copyright: "© 2025 ClixMagicAI Alle Rechte vorbehalten."
    },
    Task: {
        image: {
            imageSupportText: 'Unterstützt jpg, jpeg, png, webp, heic, heif Formate, maximal 10MB pro Datei',
            imageFileTooLarge: 'Dateigröße überschreitet Limit (max. 10MB)',
            invalidImageType: 'Nicht unterstütztes Bildformat, bitte laden Sie JPG, JPEG, PNG, WEBP, HEIC oder HEIF hoch',
            imageWillCost: 'Kostet: 1 Punkt',
            hiecSupportText: 'HEIC/HEIF-Formate werden bei der Übermittlung automatisch in PNG konvertiert',
            hiecSuccess: 'HEIC/HEIF-Format erfolgreich konvertiert',
            hiecFailed: 'HEIC/HEIF-Format Konvertierung fehlgeschlagen',
            processingImageTip: 'Ihr Bild wird verarbeitet, bitte warten...',
            guide: {
                title: 'Benutzeranleitung',
                step1: 'Bild hochladen',
                step2: 'Wasserzeichenbereich markieren oder automatische Erkennung nutzen',
                step3: 'Auf Absenden klicken'
            }
        },
        common: {
            remaining: 'Verbleibende Punkte',
            nextUpdate: 'Nächstes Guthaben-Update',
            handleError: 'Fehler bei der Dateiverarbeitung, bitte versuchen Sie eine andere Datei',
            uploadFailed: 'Datei-Upload fehlgeschlagen',
            dragText: 'Dateien hierher ziehen oder',
            clickText: 'klicken zum Hochladen',
            loginRequired: 'Bitte melden Sie sich an, bevor Sie Dateien hochladen',
            noRemainingTasks: 'Sie haben alle Ihre Punkte aufgebraucht',
            loginNow: 'Jetzt anmelden',
            upgradeNow: 'Jetzt Punkte kaufen',
            taskSubmitSuccess: 'Aufgabe erfolgreich eingereicht',
            taskSubmitError: 'Aufgabenübermittlung fehlgeschlagen',
            taskRetrySuccess: 'Aufgabenwiederholung erfolgreich eingereicht!',
            taskRetryError: 'Aufgabenwiederholung fehlgeschlagen!',
            processing: 'Verarbeitung',
            submit: 'Absenden',
            waiting: 'Warten',
            completed: 'Abgeschlossen',
            failed: 'Fehlgeschlagen',
            cancelled: 'Abgebrochen',
            url_not_found: 'Link konnte nicht abgerufen werden',
            deleted: 'Gelöscht',
            refreshSuccess: 'Aufgabenliste aktualisiert',
            refreshFailed: 'Aktualisierung der Aufgabenliste fehlgeschlagen',
            deleteSuccess: 'Aufgabe erfolgreich gelöscht',
            deleteFailed: 'Löschen der Aufgabe fehlgeschlagen',
            waitingForCompletion: 'Bitte warten Sie, bis die aktuelle Aufgabe abgeschlossen ist, bevor Sie es erneut versuchen',
            loadOriginalImageFailed: 'Laden des Originalbildes fehlgeschlagen, bitte erneut versuchen',
            downloadFailed: 'Download fehlgeschlagen',
            startingDownload: 'Download wird gestartet...',
            noTasks: 'Keine Aufgaben',
            refresh: 'Aktualisieren',
            sort: 'Sortieren',
            noFilterTasks: 'Keine {filter} Aufgaben',
            compare: 'Vergleich anzeigen',
            originalImage: 'Original',
            processedImage: 'Bearbeitet',
            dragToCompare: '👈 Ziehen zum Vergleichen 👉',
            cancel: "Abbrechen",
            delete: "Löschen",
            retry: "Wiederholen",
            download: "Herunterladen",
            createAt: "Erstellt am",
            expiredAt: "Läuft ab am",
        },
        video: {
            videoSupportText: 'Unterstützt mp4, mov, avi, mkv Formate, maximal 100MB pro Datei',
            videoFileTooLarge: 'Dateigröße überschreitet Limit (max. 100MB)',
            invalidVideoType: 'Nicht unterstütztes Videoformat, bitte laden Sie MP4, MOV, AVI oder MKV hoch',
            videoWillCost: 'Kostet: 3 Punkte',
            processingVideoTip: 'Ihr Video wird verarbeitet, bitte warten...',
            guide: {
                step1: 'Video hochladen',
                step2: 'Wasserzeichentyp auswählen und Wasserzeichenbereich definieren',
                step3: 'Auf Absenden klicken'
            },
            annotationTools: 'Wasserzeichen-Annotationswerkzeuge',
            selectType: 'Wasserzeichentyp auswählen',
            deleteAnnotation: 'Annotation löschen',
            clearAllAnnotations: 'Alle Annotationen löschen',
            annotationHelp: 'Annotationshilfe',
            dragTip: 'Ziehen, um Wasserzeichenbereich zu zeichnen',
            resizeTip: 'Größe anpassen, um Wasserzeichen zu entsprechen',
            moveTip: 'Erstellte Annotationen können verschoben werden',
            processing: 'Verarbeitung',
            submit: 'Absenden',
            taskSubmitSuccess: 'Aufgabe erfolgreich eingereicht',
            taskSubmitError: 'Aufgabenübermittlung fehlgeschlagen',
            retryTaskTip: 'Aufgabenwiederholung erfolgreich',
            retryFailed: 'Aufgabenwiederholung fehlgeschlagen',
            uploadFailed: 'Upload fehlgeschlagen',
            staticWatermarkDesc: 'Für statische Wasserzeichen an festen Positionen',
            normalWatermarkDesc: 'Für normale feste Wasserzeichen',
            dynamicWatermarkDesc: 'Für sich ändernde dynamische Wasserzeichen',
            moveWatermarkDesc: 'Für Wasserzeichen, die bewegt werden müssen'
        },
    },
    Router: {
        home: "Startseite",
        terms: "Nutzungsbedingungen",
        privacy: "Datenschutz",
        cookie: "Cookie-Richtlinie",
        user: "Benutzerzentrum",
    },
    Terms: {
        "tabs": {
            "terms": "Nutzungsbedingungen",
            "privacy": "Datenschutzrichtlinie",
            "cookies": "Cookie-Richtlinie"
        },
        "lastUpdated": "Letzte Aktualisierung: 20. Mai 2025",
        "terms": {
            "sections": [
                {
                    "title": "1. Einführung",
                    "description": "Willkommen bei ClixMagicAI. Die Nutzung unserer Dienste bedeutet, dass Sie diesen Nutzungsbedingungen zustimmen. Bitte lesen Sie diese sorgfältig durch."
                },
                {
                    "title": "2. Beschreibung der Dienste",
                    "description": "ClixMagicAI bietet KI-gestützte Tools zum Entfernen von Wasserzeichen aus Bildern und Videos. Unsere Dienste sind für die folgenden legitimen Zwecke geeignet:",
                    "items": [
                        "Entfernung von Wasserzeichen aus Ihren eigenen Inhalten",
                        "Entfernung von Wasserzeichen aus Inhalten, für deren Änderung Sie entsprechende Rechte besitzen",
                        "Bildungs- und Forschungszwecke"
                    ]
                },
                {
                    "title": "3. Nutzerverantwortung",
                    "description": "Durch die Nutzung von ClixMagicAI stimmen Sie zu, dass Sie:",
                    "items": [
                        "nur Inhalte hochladen, die Ihnen gehören oder für deren Änderung Sie die entsprechenden Rechte besitzen",
                        "unsere Dienste nicht für illegale Zwecke oder unter Verletzung von Gesetzen nutzen",
                        "nicht versuchen, unsere Sicherheitsmaßnahmen oder Nutzungsbeschränkungen zu umgehen",
                        "unsere Dienste nicht zur Verletzung geistiger Eigentumsrechte Dritter nutzen"
                    ]
                },
                {
                    "title": "4. Kontobedingungen",
                    "description": "Für die Nutzung bestimmter Funktionen unserer Dienste müssen Sie möglicherweise ein Konto erstellen. Zur Anmeldung können Sie ein Google- oder GitHub-Konto verwenden. Sie sind verantwortlich für:",
                    "items": [
                        "die Sicherheit Ihres Kontos",
                        "alle Aktivitäten, die unter Ihrem Konto stattfinden",
                        "die Bereitstellung genauer Kontoinformationen (einschließlich, aber nicht beschränkt auf Avatar, E-Mail, Benutzername und Benutzer-ID)"
                    ]
                },
                {
                    "title": "5. Kostenlose und kostenpflichtige Dienste",
                    "description": "ClixMagicAI bietet sowohl kostenlose als auch kostenpflichtige Dienste:",
                    "items": [
                        { "bold": "Kostenloser Service", "text": "Wir bieten täglich 10 kostenlose Punkte für grundlegende Wasserzeichen-Entfernungsbedürfnisse" },
                        "Basis-Kontingent: Jeder Nutzer erhält automatisch 3 kostenlose Punkte pro Tag, die für die Inhaltsverarbeitung verwendet werden können",
                        "Punktverbrauchsregeln: Die Entfernung von Wasserzeichen aus Bildern verbraucht 1 Punkt pro Vorgang, die Entfernung von Wasserzeichen aus Videos verbraucht 3 Punkte pro Vorgang",
                        "Punktkauf: Sie können Punktpakete für mehr Nutzung kaufen, alle gekauften Punkte sind dauerhaft gültig, ohne Ablaufbeschränkungen",
                        "Rückerstattungsrichtlinie: Aufgrund der sofortigen und virtuellen Natur digitaler Dienste können Punkte nach erfolgreicher Zahlung nicht zurückerstattet werden"
                    ]
                },
                {
                    "title": "6. Geistige Eigentumsrechte",
                    "description": "Der ClixMagicAI-Dienst, einschließlich aller von uns erstellten Software, Designs und Inhalte, ist unser geistiges Eigentum. Sie dürfen ohne Erlaubnis keine Kopien, Änderungen oder abgeleitete Werke auf Basis unserer Dienste erstellen."
                },
                {
                    "title": "7. Haftungsbeschränkung",
                    "description": "ClixMagicAI stellt den Dienst \"wie er ist\" ohne jegliche Garantien zur Verfügung. Wir sind nicht haftbar für Schäden, die durch Ihre Nutzung unserer Dienste entstehen."
                },
                {
                    "title": "8. Änderungen der Bedingungen",
                    "description": "Wir können diese Bedingungen jederzeit ändern. Die fortgesetzte Nutzung von ClixMagicAI nach Änderung der Bedingungen bedeutet, dass Sie die geänderten Bedingungen akzeptieren."
                },
                {
                    "title": "9. Beendigung",
                    "description": "Wir behalten uns das Recht vor, Ihren Zugang zu unseren Diensten sofort und ohne vorherige Benachrichtigung zu beenden oder auszusetzen, wenn wir der Meinung sind, dass Ihr Verhalten gegen diese Bedingungen verstößt oder anderen Nutzern, uns oder Dritten schadet."
                },
                {
                    "title": "10. Anwendbares Recht",
                    "description": "Diese Bedingungen unterliegen den geltenden Gesetzen am Ort der Registrierung unseres Unternehmens, ungeachtet von Kollisionsnormen."
                }
            ]
        },
        "privacy": {
            "sections": [
                {
                    "title": "1. Einführung",
                    "description": "Bei ClixMagicAI schätzen wir Ihre Privatsphäre und sind bestrebt, Ihre persönlichen Daten zu schützen. Diese Datenschutzrichtlinie erläutert, wie wir Ihre Informationen sammeln, verwenden und schützen, wenn Sie unsere Website und Dienste nutzen. Durch den Zugriff auf unsere Website oder die Nutzung unserer Dienste akzeptieren Sie die in dieser Richtlinie beschriebenen Datenverarbeitungspraktiken. Wir halten uns an die geltenden Datenschutzbestimmungen."
                },
                {
                    "title": "2. Informationen, die wir sammeln",
                    "description": "Wir können folgende Arten von Informationen sammeln:",
                    "items": [
                        { "bold": "Kontoinformationen", "text": "Benutzeravatar, E-Mail-Adresse, Benutzername und Benutzer-ID, die bei der Anmeldung über Google oder GitHub bereitgestellt werden" },
                        { "bold": "Nutzungsdaten", "text": "Informationen darüber, wie Sie unsere Dienste nutzen, einschließlich aufgerufener Funktionen und Nutzungszeiten" },
                        { "bold": "Hochgeladene Inhalte", "text": "Bilder oder Videos, die Sie zur Verarbeitung hochladen" },
                        { "bold": "Zahlungsinformationen", "text": "Zahlungsinformationen beim Kauf von Abonnements (werden sicher durch Zahlungs-Gateways von Drittanbietern wie Creem/Stripe/PayPal verarbeitet, wir behalten nur Zahlungsstatusdatensätze)" },
                        { "bold": "Technische Daten", "text": "IP-Adresse, Browsertyp, Geräteinformationen" }
                    ]
                },
                {
                    "title": "3. Wie wir Ihre Informationen verwenden",
                    "description": "Wir verwenden Ihre Informationen, um:",
                    "items": [
                        { "text": "Unsere Dienste bereitzustellen, zu warten und zu verbessern" },
                        { "text": "Transaktionen zu verarbeiten und abzuschließen" },
                        { "text": "Technische Benachrichtigungen und Support-Nachrichten zu senden" },
                        { "text": "Auf Ihre Kommentare und Fragen zu antworten" },
                        { "text": "Nutzungsmuster zu analysieren, um die Benutzererfahrung zu verbessern, und personenbezogene Daten nur in dem für die Erreichung der Dienstzwecke erforderlichen Umfang zu verarbeiten" },
                        { "text": "Sicherzustellen, dass die Speicherdauer personenbezogener Daten nicht länger als nötig ist" },
                        { "text": "Betrug oder illegale Aktivitäten zu verhindern" }
                    ]
                },
                {
                    "title": "4. Datensicherheit",
                    "description": "Wir implementieren branchenübliche Sicherheitsmaßnahmen zum Schutz Ihrer persönlichen Informationen:",
                    "items": [
                        { "text": "AES-256-Verschlüsselung für Dateien während der Übertragung und Speicherung" },
                        { "text": "Verarbeitung sensibler Daten mit Zero-Knowledge-Architektur" },
                        { "text": "Tägliche Sicherheitsprotokollprüfungen und Schwachstellenscans" },
                        { "text": "Mitarbeiterzugriff folgt dem Prinzip der geringsten Privilegien" }
                    ]
                },
                {
                    "title": "5. Datenweitergabe",
                    "description": "Wir verkaufen Ihre persönlichen Informationen nicht. Wir können Informationen weitergeben an:",
                    "items": [
                        { "bold": "Dienstleister", "text": "Beschränkt auf die für bestimmte Dienste erforderliche Datenverarbeitung (wie CloundFlare Cloud-Speicher, Zahlungs-Gateways von Drittanbietern wie Creem/Stripe/PayPal), die Datenverarbeitungsvereinbarungen unterzeichnen müssen" },
                        { "bold": "Gesetzliche Anforderungen", "text": "Bei Erhalt einer gültigen Vorladung, eines Gerichtsbeschlusses oder eines anderen auf uns anwendbaren Rechtsverfahrens" }
                    ]
                },
                {
                    "title": "6. Ihre Rechte",
                    "description": "Gemäß den in Ihrer Region geltenden Gesetzen haben Sie möglicherweise folgende Rechte:",
                    "items": [
                        { "text": "Zugriff auf eine Kopie Ihrer personenbezogenen Daten" },
                        { "text": "Berichtigung ungenauer oder unvollständiger Informationen" },
                        { "text": "Recht auf Löschung von Daten ('Recht auf Vergessenwerden'), es sei denn, wir haben einen rechtmäßigen Grund zur Aufbewahrung" },
                        { "text": "Widerspruch gegen oder Einschränkung bestimmter Arten der Datenverarbeitung" },
                        { "text": "Recht auf Datenübertragbarkeit, Sie können die Übertragung Ihrer Daten beantragen" }
                    ]
                },
                {
                    "title": "7. Kinderdatenschutz",
                    "description": "Unsere Dienste richten sich nicht an Minderjährige unter 16 Jahren. Gemäß Artikel 8 der Datenschutz-Grundverordnung (DSGVO) muss die Einwilligung für Kinder unter 16 Jahren von Eltern oder Erziehungsberechtigten erteilt werden. Wenn Sie erfahren, dass ein Minderjähriger unter 16 Jahren uns personenbezogene Informationen zur Verfügung gestellt hat, kontaktieren Sie uns bitte umgehend unter clixmagicai@gmail.com."
                },
                {
                    "title": "8. Änderungen dieser Richtlinie",
                    "description": "Wir können diese Datenschutzrichtlinie regelmäßig aktualisieren. Wir werden Sie über wesentliche Änderungen informieren, indem wir die neue Richtlinie auf dieser Seite veröffentlichen und das Datum der \"letzten Aktualisierung\" aktualisieren. Bei wesentlichen Änderungen werden wir die Benutzer per E-Mail oder auf andere auffällige Weise benachrichtigen."
                },
                {
                    "title": "9. Kontakt",
                    "description": "Wenn Sie Fragen zu dieser Datenschutzrichtlinie haben, kontaktieren Sie uns bitte unter clixmagicai@gmail.com. Wenn Sie der Meinung sind, dass Ihre Daten unsachgemäß verarbeitet wurden oder Sie Bedenken haben, zögern Sie nicht, uns jederzeit zu kontaktieren."
                }
            ]
        },
        "cookies": {
            "sections": [
                {
                    "title": "1. Was sind Cookies",
                    "description": "Cookies sind kleine Textdateien, die auf Ihrem Computer oder Mobilgerät platziert werden, wenn Sie eine Website besuchen. Sie ermöglichen Websites, Ihr Gerät zu erkennen und sich zu merken, ob Sie die Website zuvor besucht haben."
                },
                {
                    "title": "2. Wie wir Cookies verwenden",
                    "description": "ClixMagicAI verwendet Cookies für verschiedene Zwecke:",
                    "items": [
                        { "bold": "Notwendige Cookies", "text": "Erforderlich für die grundlegende Funktionalität unserer Website (wie Sitzungsverwaltung und Sicherheitsfunktionen)" },
                        { "bold": "Präferenz-Cookies", "text": "Speichern Ihre Einstellungen und Präferenzen, um Ihre Erfahrung zu verbessern, zum Beispiel durch Speichern Ihres Avatars, Benutzernamens usw. nach der Anmeldung über Google oder GitHub" },
                        { "bold": "Analyse-Cookies", "text": "Helfen uns zu verstehen, wie Besucher mit unserer Website interagieren, indem anonyme Informationen gesammelt werden" },
                        { "bold": "Marketing-Cookies", "text": "Verfolgen Ihre Surfgewohnheiten, um Ihnen relevante Werbung anzubieten" }
                    ]
                },
                {
                    "title": "3. Arten von Cookies, die wir verwenden",
                    "subsection": [
                        {
                            "title": "3.1 Notwendige Cookies",
                            "description": "Diese Cookies sind für den ordnungsgemäßen Betrieb der Website erforderlich. Sie ermöglichen Kernfunktionen wie Sicherheit, Netzwerkverwaltung und Kontozugriff (einschließlich Google- und GitHub-Anmeldung). Sie können Ihren Browser so einstellen, dass diese Cookies blockiert werden, aber einige Teile der Website funktionieren dann möglicherweise nicht richtig."
                        },
                        {
                            "title": "3.2 Leistungs- und Analyse-Cookies",
                            "description": "Diese Cookies helfen uns zu verstehen, wie Besucher mit unserer Website interagieren, indem sie anonyme Informationen sammeln. Wir verwenden diese Daten, um unsere Website und Dienste zu verbessern. Diese Cookies sammeln keine Informationen, die einen Besucher identifizieren können."
                        },
                        {
                            "title": "3.3 Funktionalitäts-Cookies",
                            "description": "Diese Cookies ermöglichen es unserer Website, sich an die von Ihnen getroffenen Entscheidungen (wie Sprachpräferenzen oder Anmeldestatus) zu erinnern, um erweiterte, personalisierte Funktionen bereitzustellen, wie das Speichern Ihres Anmeldestatus über Google oder GitHub."
                        },
                        {
                            "title": "3.4 Targeting- und Werbe-Cookies",
                            "description": "Diese Cookies werden verwendet, um Besuchern relevante Werbung anzuzeigen und die Effektivität unserer Werbekampagnen zu verfolgen. Bitte beachten Sie, dass unsere Website hauptsächlich auf Anmeldungen von Drittanbietern (Google und GitHub) basiert und diese Art von Cookies hauptsächlich zur Verbesserung der Benutzererfahrung und nicht für direktes Marketing verwendet wird."
                        }
                    ]
                },
                {
                    "title": "4. Cookie-Verwaltung",
                    "description": "Sie können Cookies auf verschiedene Weise kontrollieren und verwalten. Die meisten Webbrowser ermöglichen die Verwaltung von Cookie-Präferenzen. Sie können:",
                    "items": [
                        { "text": "Cookies von Ihrem Gerät löschen" },
                        { "text": "Cookies blockieren, indem Sie Browsereinstellungen aktivieren, die es Ihnen ermöglichen, einige oder alle Cookies abzulehnen" },
                        { "text": "Ihren Browser so einstellen, dass er Sie benachrichtigt, wenn Sie Cookies erhalten" }
                    ]
                },
                {
                    "title": "5. Cookies von Drittanbietern",
                    "description": "Einige Cookies werden von Drittanbietern auf unserer Website platziert. Diese Drittanbieter können Analysedienste (wie Google Analytics) und Werbenetzwerke umfassen. Aufgrund der Funktionsweise von Cookies (Cookies können nur von der Partei, die sie ursprünglich gesetzt hat, abgerufen werden), kontrollieren wir die Verwendung dieser Cookies von Drittanbietern nicht und können nicht auf sie zugreifen. Für Benutzer, die sich über Google und GitHub anmelden, stellen wir sicher, dass die Datenschutzrichtlinien dieser Plattformen beim Umgang mit relevanten Informationen eingehalten werden."
                },
                {
                    "title": "6. Aktualisierung dieser Cookie-Richtlinie",
                    "description": "Wir können diese Cookie-Richtlinie von Zeit zu Zeit aktualisieren, um Änderungen in der Technologie, den Vorschriften oder unseren Geschäftspraktiken widerzuspiegeln. Alle Änderungen werden auf dieser Seite veröffentlicht und das Überarbeitungsdatum wird aktualisiert."
                },
                {
                    "title": "7. Kontakt",
                    "description": "Wenn Sie Fragen zu unserer Verwendung von Cookies haben, kontaktieren Sie uns bitte unter clixmagicai@gmail.com."
                }
            ]
        }
    },
    UserFeedback: {
        title: "Nutzerstimmen",
        feedback: "Hören Sie echte Bewertungen von Kreativen und Fachleuten aus der ganzen Welt zu unserer KI-Bildverarbeitungstechnologie.",
        people: [
            {
                id: 1,
                avatar: "feedback-user-avatar-1.jpg",
                name: "Herr Lin",
                profession: "Videoeditor & Content Creator",
                rating: 5,
                comment: "Unglaublich! ClixMagicAI ist superschnell! Laden Sie ein Video mit Wasserzeichen hoch, und in wenigen Minuten erhalten Sie eine Version ohne Wasserzeichen, ohne jeglichen Qualitätsverlust. Ein unverzichtbares Tool zur Entfernung von Wasserzeichen!"
            },
            {
                id: 2,
                avatar: "feedback-user-avatar-2.jpg",
                name: "Frau Su",
                profession: "Social-Media-Expertin",
                rating: 5,
                comment: "ClixMagicAI hat meine Instagram-Materialbibliothek gerettet! Es erkennt auch komplexe Wasserzeichen präzise, die Kantenverarbeitung ist viel feiner als bei Software, die ich zuvor verwendet habe, und der visuelle Effekt ist natürlicher."
            },
            {
                id: 3,
                avatar: "feedback-user-avatar-3.jpg",
                name: "Herr Chen",
                profession: "Kurzvideoproduzent",
                rating: 5,
                comment: "Mit ClixMagicAI ist die Wasserzeichenentfernung super bequem. Ich bearbeite TikTok-Material auf dem Weg zur Arbeit und lade die hochauflösende Version direkt nach der Ankunft im Büro herunter. Die Effizienz hat sich verdoppelt! Ein Segen für Medienmacher."
            },
            {
                id: 4,
                avatar: "feedback-user-avatar-4.jpg",
                name: "Herr Huang",
                profession: "Grafikdesigner & Creative Director",
                rating: 5,
                comment: "Als Designer bin ich sehr zufrieden! Bei der Bearbeitung von Vorlagenbildern mit Kundenlogos wird die Hintergrundtextur sehr natürlich wiederhergestellt, ohne Spuren von Photoshop, was viel Nachbearbeitungszeit spart."
            },
            {
                id: 5,
                avatar: "feedback-user-avatar-5.jpg",
                name: "Frau Emily",
                profession: "Freiberufliche digitale Content-Erstellerin",
                rating: 5,
                comment: "Ich habe einen Schatz entdeckt! Der Mitgliedspreis ist viel günstiger als andere Wasserzeichen-Entfernungsprodukte auf dem Markt, aber die Ergebnisse sind besser, besonders bei der Bearbeitung von Verlaufs-Transparenz-Wasserzeichen zeigen sich die Vorteile deutlich."
            },
            {
                id: 6,
                avatar: "feedback-user-avatar-6.jpg",
                name: "Herr Robertson",
                profession: "Unternehmensschulungsersteller",
                rating: 5,
                comment: "ClixMagicAI ist sehr praktisch, da keine Installation erforderlich ist! Die Berechtigungsbeschränkungen auf Firmencomputern verhindern die Installation von Software, jetzt kann ich Kursmaterial mit dem Browser bearbeiten, jederzeit und überall."
            },
            {
                id: 7,
                avatar: "feedback-user-avatar-7.jpg",
                name: "Frau Zhou",
                profession: "Hausfrau & Community-Bildeditorin",
                rating: 5,
                comment: "Die Benutzeroberfläche ist so einfach, dass selbst meine Großmutter sie benutzen könnte! Für alle, die keine Zeit haben, professionelle Software wie Photoshop zu erlernen, sollten ClixMagicAI unbedingt ausprobieren. Es ist perfekt für technische Anfänger wie mich. Haha~"
            },
            {
                id: 8,
                avatar: "feedback-user-avatar-8.jpg",
                name: "Herr Johnson",
                profession: "E-Commerce Visual Planner",
                rating: 5,
                comment: "ClixMagicAI ist so leistungsstark, es kann Bilder, Videos, kleine Objekte, Passanten, Text und mehr entfernen. Die Funktionen sind umfassend, ich empfehle es allen~"
            },
            {
                id: 9,
                avatar: "feedback-user-avatar-9.jpg",
                name: "Frau Fang",
                profession: "Hobbyfotografin & Online-Content-Teilerin",
                rating: 5,
                comment: "Wow~ Endlich habe ich ein Wasserzeichen-Entfernungstool gefunden, das die Bildqualität nicht beeinträchtigt! Es ist wie Magie~ Bildbearbeitung ist kein Problem mehr! Sehr empfehlenswert!!!"
            },
            {
                id: 10,
                avatar: "feedback-user-avatar-10.jpg",
                name: "Herr Williams",
                profession: "Online-Bildungslehrer",
                rating: 5,
                comment: "Die Wasserzeichenpositions-Speicherfunktion ist super nützlich! Bei der Bearbeitung von Kursvideosequenzen muss ich nicht wiederholt Bereiche auswählen, was mindestens eine halbe Stunde Arbeitszeit spart und meine Unterrichtsvorbereitungseffizienz erheblich steigert."
            }
        ]
    },
    FAQ: {
        title: "ClixMagicAI Benutzerhandbuch und häufig gestellte Fragen",
        prompt: "Haben Sie Probleme oder Fragen? Kontaktieren Sie uns jederzeit: clixmagicai@gmail.com",
        questions: [
            {
                id : 1,
                question: "Was ist ClixMagicAI und wie funktioniert es?",
                answer: "ClixMagicAI ist ein fortschrittliches KI-gesteuertes Wasserzeichen-Entfernungstool. Es unterstützt die automatische Erkennung von Wasserzeichen in Bildern und Videos und bietet die Möglichkeit, Wasserzeichenpositionen manuell zu markieren. Für Bilder unterstützt es verschiedene Formatkonvertierungen und gewährleistet eine hochwertige Ausgabe; für Videos kann es statische, dynamische und sogar formveränderliche Wasserzeichen verarbeiten."
            },
            {
                id : 2,
                question: "Bietet ClixMagicAI eine kostenlose Nutzung an?",
                answer: "Ja, wir bieten einen kostenlosen Basisdienst mit 10 Punkten pro Tag! Sie können diese für die Bearbeitung von Bildern (1 Punkt pro Vorgang) oder Videos (3 Punkte pro Vorgang) verwenden. Derzeit ist der Kauf zusätzlicher Punkte nicht möglich, es gibt nur die täglichen 10 Gratispunkte."
            },
            {
                id : 3,
                question: "Kann ich zusätzliche Punkte kaufen?",
                answer: "Derzeit ist der Kauf zusätzlicher Punkte nicht möglich. Jeder Nutzer erhält täglich nur 10 kostenlose Punkte, die am nächsten Tag automatisch erneuert werden."
            },
            {
                id : 4,
                question: "Welche Dateiformate werden unterstützt?",
                answer: "Für Bilder unterstützen wir die Formate PNG, JPEG, JPG, WEBP, HEIC und HEIF, wobei HEIC und HEIF automatisch in PNG umgewandelt werden. Für Videos unterstützen wir verschiedene Formate, darunter MP4 und MOV."
            },
            {
                id : 5,
                question: "Wie wird meine Privatsphäre geschützt?",
                answer: "Bei ClixMagicAI legen wir großen Wert auf die Privatsphäre der Benutzer. Alle hochgeladenen Dateien werden verschlüsselt und innerhalb von 24 Stunden nach Abschluss der Verarbeitung automatisch gelöscht. Wir speichern keine Benutzerdateien oder zugehörigen Informationen."
            },
            {
                id : 6,
                question: "Wie kann ich mich bei ClixMagicAI anmelden?",
                answer: "Wir unterstützen die schnelle Anmeldung über GitHub- oder Google-Konten, was die Sicherheit Ihres Kontos gewährleistet und den Registrierungsprozess vereinfacht."
            },
            {
                id : 7,
                question: "Wie schnell erfolgt die Verarbeitung?",
                answer: "Dank unserer leistungsstarken Server und optimierten KI-Algorithmen können die meisten Bild-Wasserzeichen-Entfernungsaufgaben innerhalb von 10 Sekunden abgeschlossen werden, während die Video-Wasserzeichen-Entfernung im schnellsten Fall nur 1 Minute dauert. Die tatsächliche Zeit kann je nach Dateigröße und Komplexität variieren."
            },
            {
                id : 8,
                question: "Wie ist das Ergebnis nach der Verarbeitung?",
                answer: "Unsere KI-Modelle sind umfassend trainiert und können Wasserzeichen intelligent aus Bildern und Videos entfernen, während die Qualität des Originalinhalts erhalten bleibt. Ob automatisch erkannt oder manuell markiert, Wasserzeichen können effektiv entfernt werden, was sicherstellt, dass das Endergebnis natürlich und spurenfrei ist."
            },
            {
                id : 9,
                question: "Wie lange ist jede Aufgabe gültig?",
                answer: "Sobald eine Aufgabe abgeschlossen ist, werden die verarbeiteten Dateien 24 Stunden lang auf ClixMagicAI zum Herunterladen aufbewahrt. Nach Ablauf werden die Dateien automatisch von unseren Servern gelöscht, um Ihre Privatsphäre zu schützen."
            },
            {
                id : 10,
                question: "Was ist die maximale Dateigröße?",
                answer: "Wir akzeptieren Bilddateien mit einer maximalen Größe von 10 MB und Videodateien mit einer maximalen Größe von 100 MB. Dateien, die diese Grenzen überschreiten, müssen möglicherweise vor dem Hochladen komprimiert oder zugeschnitten werden."
            }
        ]
    },
}